import { createStore } from "vuex";
import { RootState } from "./root-state";
import { settings, SettingsStore } from "@/store/modules/settings";
import { dialogs, DialogsStore } from "@/store/modules/dialogs";
import { slyShopping, SlyShoppingStore } from "@/store/modules/slyShopping";
import { mainMenuItems, MainMenuStore } from "@/store/modules/mainMenu";
import { encrypting, EncryptStore } from "@/store/modules/encrypting";
import { store as auth, AuthStore } from "@/store/modules/auth";

export type Store = AuthStore<Pick<RootState, "Auth">> &
  SettingsStore<Pick<RootState, "Settings">> &
  DialogsStore<Pick<RootState, "Dialogs">> &
  MainMenuStore<Pick<RootState, "MenuItems">> &
  SlyShoppingStore<Pick<RootState, "SlyShopping">> &
  EncryptStore<Pick<RootState, "Encrypting">>;

export const store = createStore({
  modules: {
    auth,
    settings,
    dialogs,
    mainMenuItems,
    slyShopping,
    encrypting,
  },
});

export function useStore(): Store {
  return store as Store;
}
